import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import * as React from 'react';
import classNames from 'classnames';
import DateBody from './DateBody';
import DateHeader from './DateHeader';
import { WEEK_DAY_COUNT } from '../../utils/dateUtil';
import { createKeyDownHandler } from '../../utils/uiUtil';
import moment from 'moment';
var DATE_ROW_COUNT = 6;

function DatePanel(props) {
  var prefixCls = props.prefixCls,
      _props$panelName = props.panelName,
      panelName = _props$panelName === void 0 ? 'date' : _props$panelName,
      keyboardConfig = props.keyboardConfig,
      active = props.active,
      operationRef = props.operationRef,
      generateConfig = props.generateConfig,
      value = props.value,
      viewDate = props.viewDate,
      id = props.id,
      fieldid = props.fieldid,
      onViewDateChange = props.onViewDateChange,
      onPanelChange = props.onPanelChange,
      _onSelect = props.onSelect,
      sourceMode = props.sourceMode,
      diffValue = props.diffValue,
      headerSelect = props.headerSelect,
      showSelectMask = props.showSelectMask;
  var panelPrefixCls = "".concat(prefixCls, "-").concat(panelName, "-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return createKeyDownHandler(event, _objectSpread({
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig.addDate(value || viewDate, diff), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig.addDate(value || viewDate, diff * WEEK_DAY_COUNT), 'key');
        },
        onPageUpDown: function onPageUpDown(diff) {
          _onSelect(generateConfig.addMonth(value || viewDate, diff), 'key');
        }
      }, keyboardConfig));
    }
  }; // ==================== View Operation ====================

  var onYearChange = function onYearChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate, 'year', diff);
  };

  var onMonthChange = function onMonthChange(diff) {
    var newDate = generateConfig.addMonth(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate, 'month', diff);
  };

  var _React$useState = React.useState(sourceMode),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      sourceModeCopy = _React$useState2[0],
      setSourceModeCopy = _React$useState2[1];

  React.useEffect(function () {
    if (sourceMode && sourceMode === 'year') {
      setSourceModeCopy('decade1');
    }
  }, [sourceMode]);

  var onYearMonthChange = function onYearMonthChange() {
    var currentDate;

    if (diffValue && diffValue[0] >= 0) {
      currentDate = moment(viewDate).add(diffValue[0], 'year');
    } else {
      currentDate = moment(viewDate).subtract(-diffValue[0], 'year');
    }

    var newDate = generateConfig.addMonth(currentDate, diffValue[1]);
    onViewDateChange(newDate);
  };

  React.useEffect(function () {
    if (diffValue) {
      onYearMonthChange();
    }
  }, [diffValue]);
  return /*#__PURE__*/React.createElement("div", {
    id: id ? id + '_panel' : '' // @ts-ignore
    ,
    fieldid: fieldid && "".concat(fieldid, "_panel"),
    className: classNames(panelPrefixCls, _defineProperty({}, "".concat(panelPrefixCls, "-active"), active))
  }, /*#__PURE__*/React.createElement(DateHeader, _extends({}, props, {
    prefixCls: prefixCls,
    value: value,
    viewDate: viewDate // View Operation
    ,
    onPrevYear: function onPrevYear() {
      onYearChange(-1);
    },
    onNextYear: function onNextYear() {
      onYearChange(1);
    },
    onPrevMonth: function onPrevMonth() {
      onMonthChange(-1);
    },
    onNextMonth: function onNextMonth() {
      onMonthChange(1);
    },
    onMonthClick: function onMonthClick() {
      onPanelChange('month', viewDate);
    },
    onYearClick: function onYearClick() {
      onPanelChange('year', viewDate);
    },
    onCurrent: function onCurrent() {
      onViewDateChange(generateConfig.getNow());
    },
    sourceModeCopy: sourceModeCopy
  })), /*#__PURE__*/React.createElement(DateBody, _extends({}, props, {
    onSelect: function onSelect(date) {
      return _onSelect(date, 'mouse');
    },
    prefixCls: prefixCls,
    value: value,
    viewDate: viewDate,
    rowCount: DATE_ROW_COUNT
  })), headerSelect !== undefined && showSelectMask ? /*#__PURE__*/React.createElement("div", {
    style: {
      opacity: '0.5',
      width: '100%',
      height: '100%',
      background: '#fff',
      position: 'absolute',
      left: 0,
      zIndex: '100'
    }
  }) : null);
}

export default DatePanel;